import React from "react";
import { Col, Row } from "reactstrap";
import TotalActiveSupport from "./Widgets/TotalActiveSupport";
import TotalActiveContracts from "./Widgets/TotalActiveContracts";
import GovernmentRequests from "./Widgets/GovernmentRequests";
import TotalActivePartners from "./Widgets/TotalActivePartners";

const Widgets = () => {
  return (
    <React.Fragment>
      <Row>
        <Col md={3}>
          <TotalActiveSupport />
        </Col>

        <Col md={3}>
          <TotalActiveContracts />
        </Col>

        <Col md={3}>
          <GovernmentRequests />
        </Col>
        <Col md={3}>
          <TotalActivePartners />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Widgets;
